'use client';

import { StatusBadge, type StatusType } from '../shared';

interface StatusSectionProps {
  status: string | null | undefined;
  entityType: string;
}

export function StatusSection({ status, entityType }: StatusSectionProps) {
  // Map entity types to StatusBadge types
  const typeMap: Record<string, StatusType> = {
    rfq: 'rfq',
    po: 'po',
    vendor_response: 'vendor_response',
  };

  const badgeType = typeMap[entityType] || 'rfq';

  return (
    <div>
      <StatusBadge status={status} type={badgeType} />
    </div>
  );
}
